(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barre-annonce-lecomptoirduchapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-lcc-announce]');
    bars.forEach(function (bar) {
      var slides = bar.querySelectorAll('[data-lcc-announce-slide]');
      if (slides.length < 2) return;

      var current = 0;
      var speed = parseInt(bar.getAttribute('data-autoplay-speed'), 10) || 5000;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
      }

      setInterval(function () { goTo(current + 1); }, speed);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-bestsellers-lecomptoirduchapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-lcc-bs]');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('[data-lcc-bs-tab]');
      var panels = section.querySelectorAll('[data-lcc-bs-panel]');
      var prevBtn = section.querySelector('[data-lcc-bs-prev]');
      var nextBtn = section.querySelector('[data-lcc-bs-next]');
      var scrollbarThumb = section.querySelector('[data-lcc-bs-scrollbar-thumb]');
      var tabsEl = section.querySelector('[data-lcc-bs-tabs]');

      if (tabsEl && tabsEl.scrollWidth > tabsEl.clientWidth + 2 && window.matchMedia('(max-width: 749px)').matches) {
        var nudgeInterval = setInterval(function () {
          tabsEl.classList.add('lcc-nudge');
          setTimeout(function () {
            tabsEl.classList.remove('lcc-nudge');
          }, 700);
        }, 5000);

        var stopNudge = function () {
          clearInterval(nudgeInterval);
          tabsEl.removeEventListener('touchstart', stopNudge);
          tabsEl.removeEventListener('scroll', stopNudge);
        };
        tabsEl.addEventListener('touchstart', stopNudge, { passive: true });
        tabsEl.addEventListener('scroll', stopNudge, { passive: true });
      }

      function activePanel() {
        return section.querySelector('[data-lcc-bs-panel].is-active');
      }

      function scrollAmount(track) {
        var firstItem = track.querySelector('.lcc-bs-card-item');
        if (!firstItem) return track.clientWidth;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var track = activePanel();
        if (!track) return;

        if (scrollbarThumb) {
          var maxScroll = track.scrollWidth - track.clientWidth;
          var widthRatio = Math.min(track.clientWidth / track.scrollWidth, 1);
          var leftRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          scrollbarThumb.style.width = (widthRatio * 100) + '%';
          scrollbarThumb.style.left = (leftRatio * (100 - widthRatio * 100)) + '%';
        }

        if (!prevBtn || !nextBtn) return;
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        if (!overflowing) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
          return;
        }
        prevBtn.hidden = track.scrollLeft <= 4;
        nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-index');
          tabs.forEach(function (t) {
            var isMatch = t === tab;
            t.classList.toggle('is-active', isMatch);
            t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            var isMatch = panel.getAttribute('data-index') === index;
            panel.classList.toggle('is-active', isMatch);
            panel.hidden = !isMatch;
            if (isMatch) panel.scrollLeft = 0;
          });
          updateArrows();
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var track = activePanel();
          if (track) track.scrollBy({ left: -scrollAmount(track), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var track = activePanel();
          if (track) track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
        });
      }

      panels.forEach(function (panel) {
        panel.addEventListener('scroll', function () {
          if (panel.classList.contains('is-active')) updateArrows();
        }, { passive: true });
      });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-collections-lecomptoirduchapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-lcc-car]');
    carousels.forEach(function (car) {
      var track = car.querySelector('[data-lcc-car-track]');
      var prevBtn = car.querySelector('[data-lcc-car-prev]');
      var nextBtn = car.querySelector('[data-lcc-car-next]');
      if (!track) return;

      function scrollAmount() {
        var firstItem = track.querySelector('.lcc-car-card-item');
        if (!firstItem) return track.clientWidth;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        if (!overflowing) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
          return;
        }
        prevBtn.hidden = track.scrollLeft <= 4;
        nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-comptoir-du-chapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('[data-lcc-header]')
      : null;
    if (!header) header = document.querySelector('[data-lcc-header]');
    if (!header) return;

    var searchToggle = header.querySelector('[data-lcc-search-toggle]');
    var searchPanel = header.querySelector('[data-lcc-search-panel]');
    var searchClose = header.querySelector('[data-lcc-search-close]');
    var mobileToggle = header.querySelector('[data-lcc-mobile-toggle]');
    var mobileClose = header.querySelector('[data-lcc-mobile-close]');
    var drawer = header.querySelector('[data-lcc-mobile-drawer]');
    var overlay = header.querySelector('[data-lcc-overlay]');

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
        isOpen ? closeSearch() : openSearch();
      });
    }
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      mobileToggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay.hidden = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 250);
    }
    if (mobileToggle) mobileToggle.addEventListener('click', openDrawer);
    if (mobileClose) mobileClose.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearch();
        closeDrawer();
      }
    });

    if (header.classList.contains('lcc-header--sticky')) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
    }

    /* ──────────────────────────────────────────────────
       MINI-PANIER : tiroir déroulant depuis la droite
    ────────────────────────────────────────────────── */
    var cartDrawer  = header.querySelector('[data-lcc-cart-drawer]');
    var cartOverlay = header.querySelector('[data-lcc-cart-overlay]');
    var cartBody    = header.querySelector('[data-lcc-cart-body]');
    var cartFooter  = header.querySelector('[data-lcc-cart-footer]');
    var cartSubtotalEl = header.querySelector('[data-lcc-cart-subtotal]');
    var cartToggles = document.querySelectorAll('[data-lcc-cart-toggle]');
    var cartCloses  = header.querySelectorAll('[data-lcc-cart-close]');
    var cartCountEls = document.querySelectorAll('[data-lcc-cart-count]');
    var cartCountTextEls = document.querySelectorAll('[data-lcc-cart-count-text]');

    /* Note : {% javascript %} est un bloc statique (pas de Liquid interprété ici),
       donc la devise et la locale sont déduites côté client : la devise vient
       directement de la réponse /cart.js, la locale de l'attribut lang du document. */
    var CART_LOCALE = document.documentElement.lang || 'fr-FR';

    function cartFormatMoney(cents, currency) {
      return (cents / 100).toLocaleString(CART_LOCALE, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2
      });
    }

    function cartImageUrl(url, size) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
    }

    /* ──────────────────────────────────────────────────
       OFFRES DE LA SEMAINE (alternance A / B)
       Du lundi 00h01 au dimanche 23h59, heure de Paris.
    ────────────────────────────────────────────────── */
    var offerBox    = header.querySelector('[data-lcc-cart-offer]');
    var discountsEl = header.querySelector('[data-lcc-cart-discounts]');
    var originalEl  = header.querySelector('[data-lcc-cart-original]');
    var offerTimer  = null;
    var OFFERS = cartDrawer ? {
      enabled:   cartDrawer.dataset.offersEnabled === 'true',
      ref:       (cartDrawer.dataset.offerRefMonday || '').trim(),
      a:         cartDrawer.dataset.offerATitle || '',
      b:         cartDrawer.dataset.offerBTitle || '',
      countdown: cartDrawer.dataset.offerCountdown === 'true'
    } : { enabled: false };

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* Heure de Paris, quel que soit le fuseau du visiteur (gère l'heure d'été/hiver) */
    function parisParts(date) {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', weekday: 'short', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
      return {
        y: +p.year, m: +p.month, d: +p.day, h: +p.hour, mi: +p.minute, s: +p.second,
        wd: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(p.weekday) /* 0 = lundi */
      };
    }
    function parisToUtc(y, m, d, h, mi, s) {
      var naive = Date.UTC(y, m - 1, d, h, mi, s);
      var p = parisParts(new Date(naive));
      return naive - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - naive);
    }

    function currentOffer() {
      if (!OFFERS.enabled) return null;
      var r = /^(\d{4})-(\d{2})-(\d{2})$/.exec(OFFERS.ref);
      if (!r) return null;
      var p = parisParts(new Date());
      if (p.wd === 0 && p.h === 0 && p.mi === 0) return null; /* lundi 00h00 : entre deux offres */
      var monday = Date.UTC(p.y, p.m - 1, p.d) - p.wd * 86400000;
      var weeks = Math.round((monday - Date.UTC(+r[1], +r[2] - 1, +r[3])) / 604800000);
      var isA = ((weeks % 2) + 2) % 2 === 0;
      var sun = new Date(monday + 6 * 86400000);
      return {
        type: isA ? 'A' : 'B',
        title: isA ? OFFERS.a : OFFERS.b,
        next: isA ? OFFERS.b : OFFERS.a,
        end: parisToUtc(sun.getUTCFullYear(), sun.getUTCMonth() + 1, sun.getUTCDate(), 23, 59, 59)
      };
    }

    function startOfferTimer(end) {
      clearInterval(offerTimer);
      var el = offerBox && offerBox.querySelector('[data-offer-timer]');
      if (!el) return;
      function update() {
        var ms = end - Date.now();
        if (ms <= 0) { clearInterval(offerTimer); refreshCartDrawer(); return; }
        var mins = Math.floor(ms / 60000);
        var d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), mi = mins % 60;
        el.textContent = 'Se termine dans ' + (d ? d + ' j ' : '') + h + ' h ' + (mi < 10 ? '0' : '') + mi + ' min';
      }
      update();
      offerTimer = setInterval(update, 30000);
    }

    function renderOffer(cart) {
      if (!offerBox) return;
      var o = currentOffer();
      if (!o) { offerBox.hidden = true; clearInterval(offerTimer); return; }
      var n = cart.item_count, hint = '';
      if (cart.total_discount > 0) {
        hint = 'Vous économisez ' + cartFormatMoney(cart.total_discount, cart.currency) + ' grâce à l\'offre.';
      } else if (o.type === 'B') {
        if (n === 1) hint = 'Ajoutez un 2e article : il sera à -40 %.';
        else if (n === 2) hint = 'Ajoutez un 3e article : il sera offert.';
      }
      offerBox.innerHTML =
        '<p class="lcc-cart-offer-title">Offre de la semaine : <strong>' + esc(o.title) + '</strong></p>' +
        (hint ? '<p class="lcc-cart-offer-hint">' + hint + '</p>' : '') +
        (OFFERS.countdown ? '<p class="lcc-cart-offer-timer" data-offer-timer></p>' : '');
      offerBox.hidden = false;
      startOfferTimer(o.end);
    }

    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.hidden = false;
      cartOverlay.hidden = false;
      requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      refreshCartDrawer();
    }
    function closeCartDrawer() {
      if (!cartDrawer) return;
      clearInterval(offerTimer);
      cartDrawer.classList.remove('is-open');
      cartOverlay.hidden = true;
      document.documentElement.style.overflow = '';
      setTimeout(function () { cartDrawer.hidden = true; }, 280);
    }

    function updateCartCount(count) {
      cartCountEls.forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      cartCountTextEls.forEach(function (el) { el.textContent = count; });
    }

    function renderCartItem(item, index, currency) {
      var row = document.createElement('div');
      row.className = 'lcc-cart-item';
      row.setAttribute('data-line', index + 1);

      var variantHtml = item.variant_title
        ? '<p class="lcc-cart-item-variant">' + item.variant_title + '</p>'
        : '';

      var discountHtml = (item.line_level_discount_allocations || []).map(function (a) {
        return '<p class="lcc-cart-item-discount">' + esc(a.discount_application.title) +
               ' (−' + cartFormatMoney(a.amount, currency) + ')</p>';
      }).join('');

      row.innerHTML =
        '<a href="' + item.url + '" class="lcc-cart-item-img">' +
          '<img src="' + cartImageUrl(item.image, 160) + '" width="72" height="72" loading="lazy" alt="">' +
        '</a>' +
        '<div class="lcc-cart-item-info">' +
          '<a href="' + item.url + '" class="lcc-cart-item-title">' + item.product_title + '</a>' +
          variantHtml + discountHtml +
          '<div class="lcc-cart-item-qty">' +
            '<button type="button" class="lcc-cart-qty-btn" data-cart-qty-minus aria-label="Diminuer la quantité">−</button>' +
            '<span class="lcc-cart-qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="lcc-cart-qty-btn" data-cart-qty-plus aria-label="Augmenter la quantité">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="lcc-cart-item-side">' +
          '<div>' +
            (item.original_line_price > item.final_line_price
              ? '<s class="lcc-cart-item-compare">' + cartFormatMoney(item.original_line_price, currency) + '</s>' : '') +
            '<span class="lcc-cart-item-price">' + cartFormatMoney(item.final_line_price, currency) + '</span>' +
          '</div>' +
          '<button type="button" class="lcc-cart-item-remove" data-cart-remove aria-label="Retirer cet article">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>';

      return row;
    }

    function renderCart(cart) {
      if (!cartBody) return;

      if (!cart.items.length) {
        cartBody.innerHTML = '<p class="lcc-cart-empty">Votre panier est vide.<br><a href="' + (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '" class="lcc-cart-empty-link" data-lcc-cart-close>Continuer mes achats</a></p>';
        if (cartFooter) cartFooter.hidden = true;
      } else {
        cartBody.innerHTML = '';
        cart.items.forEach(function (item, index) {
          cartBody.appendChild(renderCartItem(item, index, cart.currency));
        });
        if (cartFooter) {
          cartFooter.hidden = false;
          if (cartSubtotalEl) cartSubtotalEl.textContent = cartFormatMoney(cart.total_price, cart.currency);
        }
      }

      if (discountsEl) {
        if (cart.total_discount > 0) {
          discountsEl.innerHTML = '<span>Vos économies</span><span>−' + cartFormatMoney(cart.total_discount, cart.currency) + '</span>';
          discountsEl.hidden = false;
        } else {
          discountsEl.hidden = true;
        }
      }
      if (originalEl) {
        originalEl.hidden = !(cart.total_discount > 0);
        originalEl.textContent = cartFormatMoney(cart.original_total_price, cart.currency);
      }
      renderOffer(cart);

      updateCartCount(cart.item_count);

      /* Ré-attacher les listeners "continuer mes achats" injectés dynamiquement */
      cartBody.querySelectorAll('[data-lcc-cart-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeCartDrawer();
        });
      });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); });
    }

    function refreshCartDrawer() {
      if (!cartBody) return;
      fetchCart().then(renderCart).catch(function () {
        cartBody.innerHTML = '<p class="lcc-cart-empty">Impossible de charger le panier.</p>';
      });
    }

    function changeLine(line, quantity, rowEl) {
      if (rowEl) rowEl.classList.add('is-updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {
          if (rowEl) rowEl.classList.remove('is-updating');
        });
    }

    if (cartBody) {
      cartBody.addEventListener('click', function (e) {
        var row = e.target.closest('.lcc-cart-item');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var qtyValueEl = row.querySelector('.lcc-cart-qty-value');
        var currentQty = qtyValueEl ? parseInt(qtyValueEl.textContent, 10) : 1;

        if (e.target.closest('[data-cart-qty-plus]')) {
          changeLine(line, currentQty + 1, row);
        } else if (e.target.closest('[data-cart-qty-minus]')) {
          changeLine(line, Math.max(0, currentQty - 1), row);
        } else if (e.target.closest('[data-cart-remove]')) {
          changeLine(line, 0, row);
        }
      });
    }

    cartToggles.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    cartCloses.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer && !cartDrawer.hidden) closeCartDrawer();
    });

    /* Sous-menus : basculent à gauche s'ils dépassent de l'écran */
    header.querySelectorAll('.lcc-dd-item.has-sub').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var sub = item.querySelector('.lcc-dd-sub');
        if (!sub) return;
        sub.classList.remove('is-flip');
        if (item.getBoundingClientRect().right + sub.offsetWidth > window.innerWidth - 8) sub.classList.add('is-flip');
      });
    });

    /* Point d'entrée appelé par la fiche produit (et tout autre formulaire ATC AJAX)
       une fois l'ajout au panier confirmé, pour ouvrir automatiquement le mini-panier. */
    window.bkOpenCart = openCartDrawer;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header2-comptoir-du-chapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.currentScript.closest('[data-lcc-header]') || document.querySelector('[data-lcc-header]');
    if (!header) return;

    var searchToggle = header.querySelector('[data-lcc-search-toggle]');
    var searchPanel = header.querySelector('[data-lcc-search-panel]');
    var searchClose = header.querySelector('[data-lcc-search-close]');
    var mobileToggle = header.querySelector('[data-lcc-mobile-toggle]');
    var mobileClose = header.querySelector('[data-lcc-mobile-close]');
    var drawer = header.querySelector('[data-lcc-mobile-drawer]');
    var overlay = header.querySelector('[data-lcc-overlay]');

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
        isOpen ? closeSearch() : openSearch();
      });
    }
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      mobileToggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay.hidden = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 250);
    }
    if (mobileToggle) mobileToggle.addEventListener('click', openDrawer);
    if (mobileClose) mobileClose.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearch();
        closeDrawer();
      }
    });

    if (header.classList.contains('lcc-header--sticky')) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-comptoir-du-chapeau"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var heroes = document.querySelectorAll('[data-lcc-hero]');
    heroes.forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-lcc-hero-slide]');
      if (slides.length < 2) return;

      var dots = hero.querySelectorAll('[data-lcc-hero-dot]');
      var prevBtn = hero.querySelector('[data-lcc-hero-prev]');
      var nextBtn = hero.querySelector('[data-lcc-hero-next]');
      var current = 0;
      var timer = null;
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 5000;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        dots[current] && dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        dots[current] && dots[current].classList.add('is-active');
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(next, speed);
      }
      function stopAutoplay() {
        if (timer) clearInterval(timer);
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
      });

      hero.addEventListener('mouseenter', stopAutoplay);
      hero.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
